<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item> -->
       
        <el-form-item label="下单时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <!-- <el-button size="small" type="primary" @click="onExport" v-auth="'/gcard/order/export'">导出</el-button> -->
          </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="searchForm.status" @tab-click="handleClick">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label="待兑换" name="1"></el-tab-pane>
          <el-tab-pane label="已兑换" name="3"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="兑换信息" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.gcard.image.file_path" alt="" /></div>
                <div class="info">
                  <div class="name gray3 product-name">
                    <span>{{ scope.row.gcard.name }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="用户">
            <template slot-scope="scope">
              <div v-if="scope.row.user && scope.row.user.nickName">{{ scope.row.user.nickName }}</div>
              <div class="gray9" v-if="scope.row.user && scope.row.user.user_id">ID：({{ scope.row.user.user_id }})</div>
              
            </template>
          </el-table-column>
          <el-table-column prop="gcard.card_type_text" label="类型">
            <template slot-scope="scope">
              <span class="gray9">{{ scope.row.gcard.card_type_text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status_text" label="状态"></el-table-column>
          <el-table-column prop="account" label="充值账号"></el-table-column>
          <el-table-column prop="card_num" label="卡号"></el-table-column>
          <el-table-column prop="card_pwd" label="卡密"></el-table-column>
          <el-table-column prop="create_time" label="时间"></el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status.value == 1" @click="cancelClick(scope.row)" type="text" size="small" v-auth="'/gcard/order/orderCancel'">取消订单</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import GcardApi from '@/api/gcard.js';
import qs from 'qs';
export default {
  data() {
    return {
      /*是否打开审核*/
      confirm_open: false,

      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        subscribe_mobile: "",
        mobile: "",
        order_no: "",
        store_id: '',
        status: '',
        create_time: ''
      },
      /*时间*/
      create_time: '',
      data1: 'all',

      dataModel:{}
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;
    this.searchForm.store_id = this.$route.query.store_id
    this.searchForm.order_no = this.$route.query.order_no

    /*获取列表*/
    this.getData();

  },
  methods: {
    
    /*导出*/
    onExport() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
    window.location.href = baseUrl + '/index.php/shop/plus.gcard.order/export?' + qs.stringify(this.searchForm);
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      console.log(tab)
      console.log(tab.name)
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      GcardApi.orderlist(Params, true)
        .then(res => {
          
          self.tableData.data = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*取消订单*/
    cancelClick(row) {
      let self = this;
      self
        .$confirm('是否要取消订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          GcardApi.orderCancel(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/gcard/order/index.vue